import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Profile.css';

function Profile({ onLogout }) {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || 'null');

  const menuItems = [
    { id: 'activity', title: 'My Activity', subtitle: 'View your orders & rides', icon: '📋', path: '/activity' },
    { id: 'wallet', title: 'Wallet', subtitle: 'Balance: $25.00', icon: '💳', path: '/wallet' },
    { id: 'rewards', title: 'Rewards', subtitle: '250 points', icon: '🏆', path: '/rewards' },
    { id: 'favorites', title: 'Saved Places', subtitle: 'Home, Work, Campus', icon: '❤️', path: '/favorites' },
    { id: 'settings', title: 'Settings', subtitle: 'Notifications, privacy', icon: '⚙️', path: '/settings' },
    { id: 'help', title: 'Help & Support', subtitle: 'FAQs, contact us', icon: '❓', path: '/help' },
    { id: 'about', title: 'About ONTAP', subtitle: 'Version 1.0.0', icon: 'ℹ️', path: '/about' }
  ];

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    if (onLogout) onLogout();
    navigate('/');
  };

  if (!user) {
    return (
      <div className="profile-page">
        <div className="login-prompt">
          <div className="prompt-icon">👤</div>
          <h2>Sign in to ONTAP</h2>
          <p>Access your rides, orders, and rewards</p>
          <Link to="/login" className="sign-in-btn">Sign In</Link>
          <Link to="/register" className="create-account-link">Create Account</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="profile-page">
      {/* Profile Header */}
      <header className="profile-header">
        <div className="profile-bg"></div>
        <div className="profile-content">
          <div className="profile-avatar">
            <span>{user.name?.charAt(0).toUpperCase()}</span>
          </div>
          <h1 className="profile-name">{user.name}</h1>
          <p className="profile-email">{user.email}</p>
          <div className="profile-stats">
            <div className="stat">
              <span className="stat-value">12</span>
              <span className="stat-label">Rides</span>
            </div>
            <div className="stat-divider"></div>
            <div className="stat">
              <span className="stat-value">4.9</span>
              <span className="stat-label">Rating</span>
            </div>
            <div className="stat-divider"></div>
            <div className="stat">
              <span className="stat-value">250</span>
              <span className="stat-label">Points</span>
            </div>
          </div>
          <button className="edit-profile-btn">Edit Profile</button>
        </div>
      </header>

      {/* Quick Actions */}
      <section className="quick-actions">
        <div className="quick-action-card" onClick={() => navigate('/wallet')}>
          <span className="qa-icon">💳</span>
          <div className="qa-info">
            <span className="qa-title">Wallet</span>
            <span className="qa-value">$25.00</span>
          </div>
        </div>
        <div className="quick-action-card" onClick={() => navigate('/rewards')}>
          <span className="qa-icon">🏆</span>
          <div className="qa-info">
            <span className="qa-title">Rewards</span>
            <span className="qa-value">250 pts</span>
          </div>
        </div>
      </section>

      {/* Menu Items */}
      <section className="menu-section">
        {menuItems.map((item) => (
          <Link key={item.id} to={item.path} className="menu-item">
            <div className="menu-item-icon">
              <span>{item.icon}</span>
            </div>
            <div className="menu-item-info">
              <span className="menu-item-title">{item.title}</span>
              <span className="menu-item-subtitle">{item.subtitle}</span>
            </div>
            <span className="menu-item-arrow">›</span>
          </Link>
        ))}
      </section>

      {/* Referral Banner */}
      <section className="referral-section">
        <div className="referral-card">
          <div className="referral-icon">🎁</div>
          <div className="referral-content">
            <h3>Invite Friends</h3>
            <p>Get $5 for each friend who signs up</p>
          </div>
          <button className="referral-btn">Share</button>
        </div>
      </section>

      {/* Logout */}
      <section className="logout-section">
        <button className="logout-btn" onClick={handleLogout}>
          <span>🚪</span>
          Sign Out
        </button>
      </section>
    </div>
  );
}

export default Profile;
